import { render, staticRenderFns } from "./TkFilter.vue?vue&type=template&id=60dcbafe&scoped=true&"
import script from "./TkFilter.vue?vue&type=script&lang=js&"
export * from "./TkFilter.vue?vue&type=script&lang=js&"
import style0 from "./TkFilter.vue?vue&type=style&index=0&id=60dcbafe&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dcbafe",
  null
  
)

export default component.exports